import type { LinkHostMode } from "@redchain/contracts";

export interface ActiveLobby {
  lobbyId: string;
  code: string;
  hostMode: LinkHostMode;
  mode: "trade" | "battle" | "wager_battle";
}

const KEY = "redchain.link.lobby";

/** Hands a lobby created or joined on /link to /play, which arms the link once the game runs. */
export function setPendingLobby(l: ActiveLobby): void {
  sessionStorage.setItem(KEY, JSON.stringify(l));
}

export function takePendingLobby(): ActiveLobby | null {
  const raw = sessionStorage.getItem(KEY);
  sessionStorage.removeItem(KEY);
  if (!raw) return null;
  try {
    const l = JSON.parse(raw) as Partial<ActiveLobby>;
    if (typeof l.lobbyId !== "string" || (l.hostMode !== "lockstep" && l.hostMode !== "server")) return null;
    return { lobbyId: l.lobbyId, code: l.code ?? "", hostMode: l.hostMode, mode: l.mode ?? "trade" };
  } catch {
    return null;
  }
}
